module.exports = __webpack_public_path__ + "img/hiddenTarif.9764e7fb.jpg";